import { render } from "./ItemsInfo.vue?vue&type=template&id=bd583be8"
import script from "./ItemsInfo.vue?vue&type=script&lang=js"
export * from "./ItemsInfo.vue?vue&type=script&lang=js"

import "./ItemsInfo.vue?vue&type=style&index=0&id=bd583be8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__